import React from "react";
import { GlobeIcon, ShieldCheckIcon, LockIcon } from "lucide-react";
import { paymentMethods } from "../../data/offer";
type CheckoutTrustProps = {
  tone?: "dark" | "light";
};
export function CheckoutTrust({
  tone = "dark"
}: CheckoutTrustProps) {
  const muted = tone === "dark" ? "text-cream/60" : "text-cocoa-light/80";
  return <div className="mt-5 space-y-5 text-center" data-id="element-563" data-mp="22417hytq77x2">
      <div className={`space-y-1.5 text-sm ${muted}`} data-id="element-564" data-mp="2ptdi934pbo1h">
        <p className="flex items-start justify-center gap-2" data-id="element-565" data-mp="2ptvjyfa4uugs">
          <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0" data-id="element-566" data-mp="2tuz1r7bqr0kn" />
          <span data-id="element-567" data-mp="2tsctf5h10h1d">En la próxima página de pago podrás pagar en tu moneda local y verás la conversión automática del precio.</span>
        </p>
        <p className="font-medium" data-id="element-568" data-mp="2kt7vo1dagrq9">Acceso inmediato • Descarga instantánea • Garantía 30 días</p>
      </div>

      <div data-id="element-569" data-mp="14eprp7ljhjkj">
        <p className={`mb-3 text-xs font-semibold uppercase tracking-wider ${muted}`} data-id="element-570" data-mp="14e6axu7ml183">Pago disponible con</p>
        <ul className="flex flex-wrap items-center justify-center gap-2" data-id="element-571" data-mp="19g5fv8j0k675">
          {paymentMethods.map(m => <li key={m.slug} className={`flex h-10 items-center gap-1.5 rounded-lg bg-white px-3 shadow-sm ring-1 ring-black/5 ${m.featured ? "ring-2 ring-[#00B1EA]" : ""}`} data-id="element-572" data-mp="3j312c2ct4jt7">
              <img src={`https://cdn.simpleicons.org/${m.slug}/${m.color}`} alt={m.name} className="h-5 w-auto max-w-[56px]" loading="lazy" data-id="element-573" data-mp="3nzrnh43gy5lh" />
              {m.label && <span className="text-[13px] font-bold" style={{
            color: `#${m.color}`
          }} data-id="element-574" data-mp="1t2wj8izq4yq">
                  {m.label}
                </span>}
            </li>)}
        </ul>
      </div>

      <div className={`mx-auto inline-flex items-center gap-3 rounded-xl border px-4 py-2.5 ${tone === "dark" ? "border-leaf/40 bg-leaf/10" : "border-leaf/30 bg-leaf-light"}`} data-id="element-575" data-mp="akmpfe0y5kls">
        <ShieldCheckIcon className="h-7 w-7 text-leaf" data-id="element-576" data-mp="kk3v3vg77yhr" />
        <div className="text-left" data-id="element-577" data-mp="khhlzrdntaxf">
          <p className={`flex items-center gap-1 text-xs font-extrabold uppercase tracking-wide ${tone === "dark" ? "text-cream" : "text-cocoa"}`} data-id="element-578" data-mp="rnaccgvmg8oj">
            <LockIcon className="h-3 w-3" data-id="element-579" data-mp="wjiyie88l257" /> Seguridad máxima
          </p>
          <p className={`text-[11px] ${muted}`} data-id="element-580" data-mp="11jwx75ny6zqk">Pago protegido con encriptación SSL de 256 bits</p>
        </div>
      </div>
    </div>;
}